/*
 * Copyright (c) 2019.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {Injectable} from '@angular/core';
import {HTTP_STATUS} from 'compob2b-libs';
import {BehaviorSubject} from 'rxjs';
import {SimpleState} from '../interfaces/SimpleState';

@Injectable({
  providedIn: 'root'
})
export class AuthStateService {

  private readonly state: SimpleState = new Map();

  /**
   * Initializing of the base auth module state
   */
  constructor() {
    this.state.set('loggedIn', new BehaviorSubject(false));
    this.state.set('error', new BehaviorSubject(false));
    this.state.set('serverError', new BehaviorSubject(false));
    this.state.set('lockedError', new BehaviorSubject(false));
    this.state.set('status', new BehaviorSubject(HTTP_STATUS.SUCCESS));
  }

  public success(status: number): void {
    this.state.get('error').next(false);
    this.state.get('status').next(status);
    this.state.get('loggedIn').next(true);
    this.state.get('serverError').next(false);
    this.state.get('lockedError').next(false);
  }

  public fail(status: number): void {
    this.state.get('error').next(true);
    this.state.get('status').next(status);
    this.state.get('loggedIn').next(false);
    this.state.get('serverError').next(false);
    this.state.get('lockedError').next(false);

  }

  public setServerError(): void {
    this.state.get('serverError').next(true);
  }

  public setLockedError(): void {
    this.state.get('lockedError').next(true);
  }

  public getState(): SimpleState {
    return this.state;
  }

}
